export const apiUrl = "https://api.funingo.fun";
// export const apiUrl = "http://localhost:8001";
export const payment_modes = ["online", "cash", "card", " Cash Online"];
export const percent_of_fm_to_use = "20";
export const razorpayKey = "rzp_live_RxNpsKlRDCdyxE";
export const flag_prices = {
  red_flag_price: 100,
  yellow_flag_price: 0.1,
  green_flag_price: 30,
  golden_flag_price: 0.1,
};
export const coinPrice = 0.1;
export const premium_prices = {
  premium_50_price_for_6_months: 5000,
  premium_50_price_for_1_year: 8000,
  premium_50_price_for_100_years: 20000,
  premium_100_price_for_6_months: 1500,
  premium_100_price_for_1_year: 2000,
  premium_100_price_for_100_years: 2500,
};
export const keysToGenerateUnqiueString = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
